import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/views/DashboardView.vue')
  },
  {
    path: '/explorer',
    name: 'Explorer',
    component: () => import('@/views/ExplorerView.vue')
  },
  {
    path: '/padic',
    name: 'Padic',
    component: () => import('@/views/PadicView.vue')
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: () => import('@/views/AnalyticsView.vue')
  },
  {
    path: '/economics',
    name: 'Economics',
    component: () => import('@/views/EconomicsView.vue')
  },
  {
    path: '/network',
    name: 'Network',
    component: () => import('@/views/NetworkView.vue')
  },
  {
    path: '/governance',
    name: 'Governance',
    component: () => import('@/views/GovernanceView.vue')
  },
  {
    path: '/governance/proposal/:id',
    name: 'ProposalDetails',
    component: () => import('@/views/ProposalDetailsView.vue'),
    props: true
  },
  {
    path: '/pouw',
    name: 'PoUW',
    component: () => import('@/views/PoUWView.vue')
  },
  {
    path: '/pouw/task/:id',
    name: 'TaskDetails',
    component: () => import('@/views/TaskDetailsView.vue'),
    props: true
  },
  {
    path: '/pouw/worker/:address',
    name: 'WorkerDetails',
    component: () => import('@/views/WorkerDetailsView.vue'),
    props: true
  },
  {
    path: '/security',
    name: 'Security',
    component: () => import('@/views/SecurityView.vue')
  },
  {
    path: '/security/window/:id',
    name: 'ChallengeWindowDetails',
    component: () => import('@/views/ChallengeWindowDetailsView.vue'),
    props: true
  },
  {
    path: '/security/fraud-proof/:id',
    name: 'FraudProofDetails',
    component: () => import('@/views/FraudProofDetailsView.vue'),
    props: true
  },
  {
    path: '/randomness',
    name: 'Randomness',
    component: () => import('@/views/RandomnessView.vue')
  },
  {
    path: '/randomness/epoch/:epoch',
    name: 'EpochDetails',
    component: () => import('@/views/EpochDetailsView.vue'),
    props: true
  },
  {
    path: '/api',
    name: 'API',
    component: () => import('@/views/ApiView.vue')
  },
  {
    path: '/events',
    name: 'EventTracking',
    component: () => import('@/views/EventTrackingView.vue')
  },
  {
    path: '/message/:id',
    name: 'Message',
    component: () => import('@/views/MessageView.vue'),
    props: true
  },
  {
    path: '/address/:address',
    name: 'Address',
    component: () => import('@/views/AddressView.vue'),
    props: true
  },
  {
    path: '/transactions',
    name: 'Transactions',
    component: () => import('@/views/TransactionsView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router